import { Component, Input } from '@angular/core';

@Component({
  selector: 'nc-animated-shiny-text',
  templateUrl: './animated-shiny-text.component.html',
  styleUrls: ['./animated-shiny-text.component.less'],
})
export class AnimatedShinyTextComponent {
  /** 文本内容 */
  @Input() ncText: string = '';
  /** 闪光条宽度 */
  @Input() ncShimmerWidth: number = 100;
  /** 文本颜色 */
  @Input() ncTextColor: string = 'rgba(82, 82, 82, 0.7)';
  /** 闪光颜色 */
  @Input() ncShinyColor: string = 'rgba(0, 0, 0, 0.8)';
  /** 动画时长，单位ms */
  @Input() ncDuration: number = 8000;
}
